import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import prop from 'ramda/es/prop';
import isEmpty from 'ramda/es/isEmpty';
import { withTranslation } from 'react-i18next';

import { subscribeBundle } from 'app/actions/apps/subs/bundle';


export default compose(
  branch(({ tariff }) => isEmpty(prop('sms_bundles', tariff)), renderNothing),

  withTranslation('tariff'),

  connect(
    state => ({
      bundleSubscribing: state.apps.opts.bundleSubscribing,
    })
  ),


  withState('state', 'setState', 'info'), // edit | info
  withState('currentBundleId', 'setCurrentBundleId', 0),
  withState('comment', 'setComment', ''),


  withHandlers({
    handleConnect: ({ setState }) => (e) => {
      e.preventDefault();
      setState('edit');
    },

    handleSubmit: ({ dispatch, subId, currentBundleId, setState }) => async (e) => {
      e.preventDefault();
      const res = await dispatch(subscribeBundle(subId, currentBundleId));
      if (res) {
        setState('info');
      }
    },

    handleBack: ({ setState }) => (e) => {
      e.preventDefault();
      setState('info');
    },

    handleChangeCurrent: ({ setCurrentBundleId, setComment, tariff, t }) => (e) => {
      const { name } = e.currentTarget;
      const id = parseInt(name.replace(/^\D+/g, ''), 10);
      setCurrentBundleId(id);
      if (tariff && (tariff.sms_bundles instanceof Array)) {
        const curr = tariff.sms_bundles.find(obj => obj.id === id);
        setComment(
          (curr.count && curr.cost)
            ? t('sms_bundles_count_confirm', { count: curr.count, cost: curr.cost })
            : t('sms_bundles_confirm')
        );
      }
    },
  })
);
